import { get, put, publicGet, publicPost } from './_httpClient';

export async function getOwnProfile() {
  return get('/users/me');
}

export async function getGlobalProfile() {
  const { status, message, data } = await get('/users/profile');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getOwnFullProfile({ batchId }) {
  const { status, message, data } = await get(`/clp/me?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getOwnBCFProfile() {
  const { status, message, error, data } = await get('/bcf/users/me');
  return { status, error, message, data };
}

export async function getCheckUsersByNim({ nim }) {
  const { status, message, data } = await publicGet(`/clp/users/${nim}/update`);
  if (status !== 'success') {
    return { status, message, data: null };
  }
  return { status, message: null, data };
}

export async function getProfileByNim({ nim }) {
  const { status, message, data } = await publicPost(
    `/clp/users/${nim}/update`,
    {},
  );
  if (status !== 'success') {
    return { status, message, data: null };
  }
  return { status, message: null, data };
}

export async function updateProfile({ payload }) {
  const { status, message, data } = await put('/clp/me', payload);
  if (status !== 'success') {
    return { status, message, data: null };
  }
  return { status, message: null, data };
}

export async function updateProfilePicture({ imageUrl }) {
  const { status, message, data } = await put('/clp/me/profile-picture', {
    imageUrl,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getAllUsers({ batchId, page, pageSize }) {
  const { status, message, data } = await get(
    `/clp/users?batchId=${batchId}&pageSize=${pageSize}&page=${page}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getUsersById({ id }) {
  const { status, message, data } = await get(`/clp/users/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function assignUserInstitution({ id, divisionInstitutionsId, isForce = false }) {
  const query = isForce ? '?isForce=true' : '';
  const { status, message, canForce, details, warning, mentorMismatch } = await put(
    `/clp/users/${id}/institution${query}`,
    { divisionInstitutionsId },
  );
  if (status !== 'success') {
    const error = new Error(message);
    error.canForce = canForce;
    error.details = details;
    throw error;
  }
  return { message, warning, mentorMismatch };
}

export async function exportUsers({ kepulangan }) {
  const { status, message, data } = await get(
    `/clp/admin/exports/users?status=${kepulangan}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}
